<template>
    <div class="container-fluid">
      <div class="row">
        <div class="col-sm bg-light border py-2">
            <table id="myLabResultTable" class="table table-sm table-hover table-striped table-bordered" style="width: 100%;">
                <thead class="text-white" style="background:Navy">
                <tr>
                    <th title="รับชำระเงิน">Paid</th>
                    <th>สถานะ</th>
                    <th>ชื่อสาขา</th>
                    <th>เลขที่ใบตรวจ</th>
                    <th>วันที่</th>
                    <th>ชื่อ-สกุล คนไข้</th>
                    <th>เพศ</th>
                    <th>อายุ(ปี)</th>
                    <th>คลินิกต้นทาง</th>
                    <th>ชำระโดย</th>
                    <th>สุทธิ</th>
                    <th>ประเภทการตรวจ</th>
                    <th>คำสั่ง</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="item in datalists" :key="item.ROID" v-bind:data-id="item.ROID">
                    <td class="">{{ arrPaid[item.Paid] }}</td>
                    <td class="">
                      <button id="btnGroupDrop1" type="button"
                          class="btn btn-outline btn-sm dropdown-toggle p-0" data-bs-toggle="dropdown" aria-expanded="false">
                          {{ arrDocStatus[item.Status] }}
                      </button>
                      <ul class="dropdown-menu pe-3" aria-labelledby="btnGroupDrop1">
                        <li class="mx-2 text-danger dropdown-item" @click="StatusPreviousStep(item)" v-if="item.Status>0" title="ถอยสถานะกลับไปก่อนหน้า"> ถอยสถานะกลับไปก่อนหน้า </li>
                      </ul>
                    </td>
                    <td class="text-start">{{ item.BranchName }}</td>
                    <td class="text-start" :title=' "สิ่งส่งตรวจ : "+item.Specimen'>{{ item.RONo }}</td>
                    <td class="text-start">{{ item.DocDate }}</td>
                    <td class="text-start">{{ item.PatName }} {{ item.PatLName}}</td>
                    <td class="">{{ arrSex[item.Sex] }}</td>
                    <td class="text-center">{{ item.AgeYears }}.{{ item.AgeMonths }}</td>
                    <td class="text-start">{{ item.ReqClinicName }}</td>
                    <td class="text-start">{{ arrPayType[item.PayType] }}</td>
                    <td class="text-end">{{  numeralFormat(item.NetAmt, '0,0[.]00') }}</td>
                    <td class="text-start">{{ item.Test }} <span v-if="item.Test.length>0 && item.TestInPropack.length>0">/</span> {{ item.TestInPropack }}</td>
                    <td  >
                      <button type="button" class="btn btn-primary btn-sm mx-1" title="ป้อนผลแล็บ"
                        id="Edit" @click="entryResultRO(item)">Edit</button>
                      <button type="button" class="btn btn-success btn-sm mx-1" title="แสดงรายการสั่งตรวจ" data-bs-toggle="modal" data-bs-target="#viewDetailModal"
                        id="View" @click="viewDetailRO(item)">View</button>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
      </div>
    </div>

    <!-- Modal แสดงหน้าต่างรายการสั่งตรวจ -->
    <div id="viewDetailModal" class="modal" tabindex="-1">
        <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">รายการสั่งตรวจ</h5>
            </div>
            <div class="modal-body">
              <table id="myRODetailTable" class="table table-sm table-hover table-striped table-bordered" style="width: 100%;">
                  <thead class="text-white" style="background:black">
                  <tr>
                      <th>รหัสชุดตรวจ</th>
                      <th>ชุดตรวจ</th>
                      <th>Specimen</th>
                      <th>ราคา</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="(item, index) in dataDtllists" :key="item.TestID">
                      <td class="text-start">{{index+1}}.&nbsp;{{ item.TestCode }}</td>
                      <td class="text-start">{{ item.TestName }}</td>
                      <td class="text-start">{{ item.Specimen }}</td>
                      <td class="text-start">{{ numeralFormat(item.UnitPrice, '0,0[.]00') }}</td>
                  </tr>
                  </tbody>
              </table>
            </div>

            <div class="modal-footer">
              <div class="container">
                <button type="button" class="btn btn-secondary pull-right" data-bs-dismiss="modal">Close</button>
              </div>
            </div>
        </div>
        </div>
    </div>
</template>

<script>
// import axios from 'axios'
import { MyApiClient } from '../myjs/my-api-client.js'
// Bootstrap and jQuery libraries
import 'bootstrap/dist/css/bootstrap.min.css'
import 'jquery/dist/jquery.min.js'
// Datatable Modules
import 'datatables.net-dt/js/dataTables.dataTables'
import 'datatables.net-dt/css/jquery.dataTables.min.css'
import $ from 'jquery'
import Swal from 'sweetalert2'
import { inject, ref } from 'vue'

export default {
  setup () {
    var globalCorpID = inject('corpID', ref(-1))
    var globalCorpName = inject('corpName', ref(''))
    var globalBranchID = inject('branchID', ref(-1))
    var globalUserID = inject('userID', ref(-1))
    var globalUserName = inject('userName', ref(''))
    var globalUserOfficialName = inject('userOfficialName', ref(''))
    var globalUserPosition = inject('userPosition', ref(''))
    var globalCorpInfo = inject('corpInfo', {})
    return {
      globalCorpID, globalCorpName, globalBranchID, globalUserID, globalUserName, globalUserOfficialName, globalUserPosition, globalCorpInfo
    }
  },
  name: 'LabResult1View',
  data () {
    return {
      dataDtllists: [],

      arrSex: ['', 'ชาย', 'หญิง'],
      arrDocStatus: ['New', 'Lab', 'Resulted', 'AP'],
      arrPayType: ['เงินสด', 'เครดิต'],
      arrPaid: ['', 'Paid']

    }
  },
  props: ['datalists'],
  mounted () {

  },
  components: {

  },
  methods: {
    // Popup รายการในใบสั่งตรวจ View อย่างเดียว
    viewDetailRO (item) {
      this.getDataDetail(item.ROID)
    },
    // ดึง DETAIL : รายการเทสในใบสั่งตรวจ
    getDataDetail (ROID) {
      MyApiClient.get('getdata/reqdtl_where_id.php?ID=' + ROID)
        .then((resp) => {
          this.dataDtllists = resp.data.response
          if (this.dataDtllists == null) {
            this.dataDtllists = []
            Swal.fire({ icon: 'info', text: 'ไม่มีข้อมูล', showConfirmButton: false, timer: 1000 })
          }
          // setTimeout(function () { $('#myRODetailTable').DataTable() }, 0)
        })
        .catch((err) => {
          console.log(err.response)
        })
    },
    StatusPreviousStep (row) {
      var stepBack = 1
      if (this.globalCorpInfo.StatusStep === '1' && row.Status === '2') {
        // 0-New - 2-Result 3-AP : ถอยสถานะจาก 2-Result ข้ามสถานะ 2-Lab เป็น 0-New
        stepBack = 2
      }
      var self = this
      Swal.fire({
        title: this.arrDocStatus[row.Status] + ' &#8594; ' + this.arrDocStatus[row.Status - stepBack] +
              '<br>คุณต้องการถอยสถานะกลับไป<br>"สถานะก่อนหน้า"<br>ใช่หรือไม่?',
        text: row.RONo + '\n' + row.PatName + ' ' + row.PatLName,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'ใช่! แน่ใจ',
        cancelButtonText: 'ยกเลิก'
      }).then((result) => {
        if (result.isConfirmed) {
          $.ajax({
            type: 'POST',
            url: this.http_baseurl + 'setdata/update_ro_status_previous.php',
            data: { ROID: row.ROID, UserID: self.globalUserID, StatusPrevious: row.Status - stepBack }
          }).done(function () {
            Swal.fire({
              text: 'ถอยสถานะเสร็จเรียบร้อย',
              icon: 'success',
              showConfirmButton: false,
              timer: 1500
            }).then((result) => {
              self.backPageAfterBackStatus()
            })
          })
        }
      })
    },
    entryResultRO (row) {
      this.$emit('onEntryResultEvent', row)
    },
    backPageAfterBackStatus () {
      this.$emit('onBackPageAfterBackStatusEvent')
      // console.log('send EMIT: backPageAfterBackStatus')
    }
  }
}
</script>

<style>

</style>
